/**************************************************
 * Nombre:       Tarjeta_Grafica_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BORDER, SOMBRA, TEXTO, TEXTOCLARO} from "../../ContantesColorGraficas";
import {useObtenerAncho} from "../../Hooks/useObtenerAncho";
import {useRef} from "react";

const Tarjeta_Grafica_Funnel = ({
                                                   subtitulo,
                                                   titulo,
                                                   Grafica,
                                                   labels,
                                                   series,
                                                   height = 'auto',
                                                   marginTop = 0
                                               }) => {
    const refe = useRef()
    const {ancho} = useObtenerAncho({contenedor: refe})


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 0,
                border: 0,
                boxShadow: '0',
                p: 2,
                height: '100%',
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{color: TEXTO, fontSize: 20, fontWeight: 700}}>{titulo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{
                    color: TEXTOCLARO,
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1.1
                }}>{subtitulo}</Typography>
            </Grid>


            <Grid ref={refe} container size={{xs: 12, sm: 12, md: 12}}
                   sx={{px: 0, py: 0, justifyContent: 'center'}}>
                <Grafica ancho={ancho} labels={labels} series={series} height={height} marginTop={marginTop}/>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Grafica_Funnel